<template>
  <div class="container">
    <el-row>
      <el-col :span="3">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                     :rr-type="this.rr_type" title="原始记录（CMA）"
                     :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
      </el-col>
      <el-col :span="21">
        <Toolbar
            :inspectStatus="inspect_status"
            :buttons="[
              // {text:'新增', type: 'primary', onClick: handleAdd}
            ]"
            :currentRoute="currentRoute"
            :projectId="project_id"
            :siteId="site_id"
            :siteType="site_type"
        />
        <hr>
        <div class="form-style">
          <el-form style="margin: 0" ref="form" :model="form" :inline="true" size="mini">
            <el-form-item label="仪器名称">
              <el-select v-model="form.yqmc1" @change="yqmc1Change"
                         placeholder="请选择">
                <el-option v-for="item in yqmc1Options" :key="item.value" :label="item.label"
                           :value="item.value">
                  <span style="float: left">{{ item.label | yq_spilt1(item.label) }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                      item.label | yq_spilt2(item.label)
                    }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="仪器编号+校准有效期">
              <el-select style="width: 100%" v-model="form.yqbh1yqyxq1" @change="yq1Change"
                         placeholder="请选择">
                <el-option v-for="item in yq1Options" :key="item.value" :label="item.label"
                           :value="item.value">
                  <span style="float: left">{{ item.label | yq_spilt1(item.label) }}</span>
                  <span
                      style="float: right; color: #8492a6; font-size: 13px">{{
                      item.label | yq_spilt2(item.label)
                    }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="仪器名称">
              <el-input v-model="form.yqmc2" disabled></el-input>
            </el-form-item>
            <el-form-item label="仪器编号+校准有效期">
              <el-select style="width: 100%" v-model="form.yqbh2yqyxq2" @change="yq2Change"
                         placeholder="请选择">
                <el-option v-for="item in yq2Options" :key="item.value" :label="item.label"
                           :value="item.value">
                  <span style="float: left">{{ item.label | yq_spilt1(item.label) }}</span>
                  <span
                      style="float: right; color: #8492a6; font-size: 13px">{{
                      item.label | yq_spilt2(item.label)
                    }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="环境温度（℃）">
              <el-input v-model="form.hjwd" placeholder="（℃）"></el-input>
            </el-form-item>
            <el-form-item label="环境湿度（%RH）">
              <el-input v-model="form.hjsd" placeholder="（%RH）"></el-input>
            </el-form-item>
            <el-form-item label="接地系统">
              <el-select v-model="form.jdxt" clearable placeholder="请选择接地系统" style="width: 100%">
                <el-option label="TT系统" value="TT系统"></el-option>
                <el-option label="TN-C系统" value="TN-C系统"></el-option>
                <el-option label="TN-S系统" value="TN-S系统"></el-option>
                <el-option label="TN-C-S系统" value="TN-C-S系统"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item>
              <el-button v-if="inspect_status" size="mini" type="success" @click="handleFormSubmit">保存</el-button>
            </el-form-item> -->
          </el-form>
        </div>
        <el-table :data="tableData" :header-cell-style="{background:'#B4DDD1',color:'#555'}"
                  style="width: 100%;margin-top:20px;">
          <el-table-column border label="序号" prop="id"></el-table-column>
          <el-table-column border label="被检测设备位置" prop="bjcsbwz"></el-table-column>
          <el-table-column border label="被检测设备名称" prop="bjcsbmc"></el-table-column>
          <el-table-column border label="实测阻值" prop="sczz"></el-table-column>
          <el-table-column border label="β值" prop="beita"></el-table-column>
          <el-table-column border label="隐患等级" prop="level"></el-table-column>
          <el-table-column border label="检测结果" prop="jcjg"></el-table-column>
          <el-table-column border label="备注" prop="remark"></el-table-column>
          <el-table-column border label="图片" prop="images">
            <template v-slot="scope">
              <img :src="scope.row.url" width="70" height="70" @click="previewPic(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column border label="操作" min-width="120" fixed="right">
            <template v-slot="scope">
              <el-button v-if="inspect_status" type="text" size="mini" @click="handleEdit(scope.row)">修改</el-button>
              <el-button v-if="inspect_status" type="text" size="mini" style="color: red"
                         @click="handleDelete(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
                       :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
      </el-col>
    </el-row>
    <!--新增-->
    <el-dialog title="新增" :visible.sync="addModel.addShow" width="800px">
      <el-form ref="addForm" :model="addModel" label-width="150px" size="small">
        <el-form-item label="被检测设备位置">
          <el-input v-model="addModel.bjcsbwz"></el-input>
        </el-form-item>
        <el-form-item label="被检测设备名称">
          <el-input v-model="addModel.bjcsbmc"></el-input>
        </el-form-item>
        <el-form-item label="实测阻值（Ω）">
          <el-input v-model="addModel.sczz"></el-input>
        </el-form-item>
        <el-form-item label="β值">
          <el-input v-model="addBt" disabled></el-input>
        </el-form-item>
        <el-form-item label="隐患等级">
          <el-input v-model="addLevel" disabled></el-input>
        </el-form-item>
        <el-form-item label="检测结果">
          <el-input v-model="addJg" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addModel.remark"></el-input>
        </el-form-item>
        <el-form-item label="图片(符合要求不用传)">
          <el-upload action="https://dq-back.wzfire.com/upload_file"
                     name="upload_file"
                     ref="upload"
                     :limit="1"
                     :on-remove="handleRemove"
                     :on-success="uploadSuccess"
                     :headers="headers"
                     accept=".jpeg,.jpg,.png"
                     :data="uploadData"
          >
            <el-button size="small" type="warning">上传图片</el-button>
            <div slot="tip" class="el-upload__tip">只能上传1张jpg/png文件，且不超过10M</div>
          </el-upload>
        </el-form-item>
        <el-form-item style="margin-left:200px;margin-top: 30px">
          <el-button type="primary" @click="onAdd">新增</el-button>
          <el-button type="info" @click="onAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="修改" :visible.sync="editModel.editShow" width="800px">
      <el-form ref="editForm" :model="editModel" label-width="120px" size="small">
        <el-form-item label="序号">
          <el-input v-model="editModel.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="被检测设备位置">
          <el-input v-model="editModel.bjcsbwz"></el-input>
        </el-form-item>
        <el-form-item label="被检测设备名称">
          <el-input v-model="editModel.bjcsbmc"></el-input>
        </el-form-item>
        <el-form-item label="实测阻值">
          <el-input v-model="editModel.sczz"></el-input>
        </el-form-item>
        <el-form-item label="β值">
          <el-input v-model="editBt" disabled></el-input>
        </el-form-item>
        <el-form-item label="隐患等级">
          <el-input v-model="editLevel" disabled></el-input>
        </el-form-item>
        <el-form-item label="检测结果">
          <el-input v-model="editJg" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editModel.remark"></el-input>
        </el-form-item>
        <el-form-item style="margin-left:200px;margin-top: 30px">
          <el-button type="primary" @click="onEdit">修改</el-button>
          <el-button type="info" @click="onEditClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--预览图片-->
    <el-dialog :visible.sync="pictureModel.dialogVisible" :modal="false" v-model="pictureModel" title="图片预览"
               width="50%">
      <img :src="pictureModel.previewpic" alt="" width="100%"/>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="pictureModel.dialogVisible = false">确定</el-button>
          </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import Toolbar from "@/components/Toolbar.vue";

let token = Vue.$Config.userinfo.token
export default {
  components: {Toolbar},
  data() {
    return {
      headers: {Authorization: token},
      uploadData: {
        project_id: '',
        site_id: '',
        site_type: '',
      },
      currentRoute: 'record_cma_index',
      project_id: '',
      site_id: '',
      site_type: '',
      rr_type: 'record',
      inspect_status: false,
      pagination: {current_page: 1, total: 1, per_page: 10,},
      form: {
        yqmc1: '',
        yqbh1: '',
        yqyxq1: '',
        yqmc2: '数字温湿度计',
        yqbh2: '',
        yqyxq2: '',
        hjwd: '',
        hjsd: '',
        jdxt: '',
        yqbh1yqyxq1: '',
        yqbh2yqyxq2: '',
      },
      yqmc1Options: [
        {label: '接地电阻测试仪', value: '接地电阻测试仪'},
        {label: '钳形接地电阻测试仪', value: '钳形接地电阻测试仪'},
      ],
      yq1Options: [],
      yq2Options: [],
      tableData: [],
      addModel: {
        addShow: false,
        bjcsbwz: '',
        bjcsbmc: '接地电阻',
        sczz: '',
        jcjg: '',
        remark: '',
        image_ids: []
      },
      editModel: {
        editShow: false,
        id: '',
        project_id: '',
        site_id: '',
        bjcsbwz: '',
        bjcsbmc: '接地电阻',
        sczz: '',
        jcjg: '',
        remark: ''
      },
      pictureModel: {
        dialogVisible: false,
        previewpic: '',
      },
    }
  },
  methods: {
    //预览图片
    previewPic(row) {
      this.pictureModel.previewpic = row.url
      this.pictureModel.dialogVisible = true
    },
    handleRemove(file, fileList) {
      try {
        this.addModel.image_ids.filter(item => item !== file.response.data.file_id)
        this.$Api.post('del_upload_file', {id: file.response.data.file_id})
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    uploadSuccess(response, file, fileList) {
      this.addModel.image_ids.push(response.data.file_id)
    },
    async yqmc1Change(val) {
      try {
        this.yqbh1yqyxq1 = ""
        this.yq1Options = []
        this.$forceUpdate()
        let yq1 = await this.$Api.post('get_device_info', {
          'device_name': val
        })
        if (yq1) {
          yq1.forEach(item => {
            this.yq1Options.push({
              label: item.device_id + ',' + item.calibrate_date,
              value: item.device_id + ',' + item.calibrate_date
            })
          })
        }

      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getYq2() {
      try {
        this.yq2Options = []
        this.yqbh1yqyxq1 = ""
        let yq2 = await this.$Api.post('get_device_info', {
          'device_name': this.form.yqmc2
        })
        yq2.forEach(item => {
          this.yq2Options.push({
            label: item.device_id + ',' + item.calibrate_date,
            value: item.device_id + ',' + item.calibrate_date
          })
        })
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    yq1Change(val) {
      this.form.yqbh1yqyxq1 = val
      this.$forceUpdate()
    },
    yq2Change(val) {
      this.form.yqbh2yqyxq2 = val
      this.$forceUpdate()
    },
    async handleFormSubmit() {
      try {
        let params = this.form
        params.project_id = this.project_id
        params.site_id = this.site_id
        if (this.form.yqbh1yqyxq1) {
          let yq_arr = this.form.yqbh1yqyxq1.split(',')
          params.yqbh1 = yq_arr[0]
          params.yqyxq1 = yq_arr[1]
        }
        if (this.form.yqbh2yqyxq2) {
          let yq_arr = this.form.yqbh2yqyxq2.split(',')
          params.yqbh2 = yq_arr[0]
          params.yqyxq2 = yq_arr[1]
        }
        await this.$Api.post('record_cma_jddz1', params)
        this.$message.success('提交成功')
        await this.getForm()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleEdit(row) {
      Object.keys(row).forEach(key => {
        if (this.editModel.hasOwnProperty(key)) {
          this.editModel[key] = row[key]
        }
      })
      this.editModel.editShow = true
    },
    async onEdit() {
      try {
        let params = {
          id: this.editModel.id,
          project_id: this.editModel.project_id,
          site_id: this.editModel.site_id,
          bjcsbwz: this.editModel.bjcsbwz,
          bjcsbmc: this.editModel.bjcsbmc,
          sczz: this.editModel.sczz,
          beita: this.editBt,
          jcjg: this.editJg,
          level: this.editLevel,
          remark: this.editModel.remark
        }
        await this.$Api.post('edit_record_cma_jddz', params)
        this.$message.success('编辑成功')
        this.initModel(this.editModel)
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onEditClose() {
      this.editModel.editShow = false
      this.initModel(this.editModel)
    },
    handleDelete(row) {
      this.$confirm('确认删除?', '确认删除', {
        confirmButtonClass: '确认',
        cancelButtonClass: '取消',
        type: 'warning'
      }).then(
          async () => {
            try {
              await this.$Api.post('del_record_cma_jddz', {'id': row.id})
              this.$message.success('删除成功')
              await this.getList()
            } catch (e) {
              this.$message.error(e.errormsg)
            }
          }
      )
    },
    //初始化对话框
    initModel(model) {
      Object.keys(model).forEach(key => {
        if (key === 'addShow' || key === 'editShow') {
          model[key] = false
        } else if (key === 'image_ids') {
          model[key] = []
        } else {
          model[key] = ''
        }
      })
    },
    //新增项目
    handleAdd() {
      if (this.form.jdxt) {
        this.addModel.addShow = true
      } else {
        this.$message.error("请先选择接地系统")
      }
    },
    async onAdd() {
      try {
        let params = this.addModel
        delete params.addShow
        params.project_id = this.project_id
        params.site_id = this.site_id
        params.beita = this.addBt
        params.jcjg = this.addJg
        params.level = this.addLevel
        params.image_ids = this.addModel.image_ids.join(',')
        await this.$Api.post('record_cma_jddz', params)
        this.$message.success('新增成功')
        location.reload()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onAddClose() {
      this.addModel.addShow = false
      this.initModel(this.addModel)
    },
    async getForm() {
      try {
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
        }
        let res = await this.$Api.get("record_cma_jddz1", {params: params});
        if (res) {
          this.form = res
          if (this.form.yqbh1 && this.form.yqyxq1) {
            this.form.yqbh1yqyxq1 = this.form.yqbh1 + ',' + this.form.yqyxq1
          }
          if (this.form.yqbh2 && this.form.yqyxq2) {
            this.form.yqbh2yqyxq2 = this.form.yqbh2 + ',' + this.form.yqyxq2
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getList() {
      try {
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("record_cma_jddz", {params: params});
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: Number(data.per_page)
        }
        this.tableData = data.data;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    changePage() {
      this.getList();
    },
    //设置操作按钮的状态
    async setButtonStatus() {
      try {
        let res = await this.$Api.post('get_site_status', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          status_type: 'cma'
        })
        if (res) {
          if (res === '检测中' || res === '已完成') {
            this.inspect_status = true
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    }
  },
  filters: {
    yq_spilt1: function (str) {
      let arr = str.split(",")
      return arr[0]
    },
    yq_spilt2: function (str) {
      let arr = str.split(",")
      return arr[1]
    }
  },
  computed: {
    addBt: function () {
      if (this.form.jdxt === 'TT系统' || this.form.jdxt === 'TN-S系统' || this.form.jdxt === 'TN-C系统') {
        return this.addModel.sczz / 4
      } else {
        return this.addModel.sczz / 10
      }
    },
    addJg: function () {
      if (['TT系统', 'TN-C系统', 'TN-S系统'].includes(this.form.jdxt) && ['A', 'B', 'C'].includes(this.addLevel)) {
        return '接地线接地电阻超过4Ω'
      } else if (this.form.jdxt === 'TN-C-S系统' && ['A', 'B', 'C'].includes(this.addLevel)) {
        return '接地线接地电阻超过10Ω'
      } else {
        return '符合要求'
      }
    },
    addLevel: function () {
      if (this.addBt >= 3) {
        return 'A'
      } else if (this.addBt >= 2 && this.addBt < 3) {
        return 'B'
      } else if (this.addBt >= 1 && this.addBt < 2) {
        return 'C'
      } else {
        return '--'
      }
    },
    editBt() {
      if (this.form.jdxt === 'TT系统' || this.form.jdxt === 'TN-S系统' || this.form.jdxt === 'TN-C系统') {
        return this.editModel.sczz / 4
      } else {
        return this.editModel.sczz / 10
      }
    },
    editLevel: function () {
      if (this.editBt >= 3) {
        return 'A'
      } else if (this.editBt >= 2 && this.editBt < 3) {
        return 'B'
      } else if (this.editBt >= 1 && this.editBt < 2) {
        return 'C'
      } else {
        return '--'
      }
    },
    editJg: function () {
      if (['TT系统', 'TN-C系统', 'TN-S系统'].includes(this.form.jdxt) && ['A', 'B', 'C'].includes(this.editLevel)) {
        return '接地线接地电阻超过4Ω'
      } else if (this.form.jdxt === 'TN-C-S系统' && ['A', 'B', 'C'].includes(this.editLevel)) {
        return '接地线接地电阻超过10Ω'
      } else {
        return '符合要求'
      }
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.uploadData.project_id = this.$route.params.project_id
    this.uploadData.site_id = this.$route.params.site_id
    this.uploadData.site_type = this.$route.params.site_type
    this.setButtonStatus()
    this.getList()
    this.getForm()
    this.getYq2()
  }
}
</script>
<style scoped>
.form-style {
  margin: 12px 0;
  border: 1px solid #028D66;
  padding: 24px 0 0 24px;
  background-color: #ffffff;
}
</style>
